module.exports = __webpack_public_path__ + "img/icon.8921a958.png";